module.exports = __webpack_public_path__ + "static/media/iconThree.7b2c3e52.svg";